/** 사용자에게 노출되는 공통 메시지 */
export const MSG = {
  apiFail: '서버 통신중 오류가 발생했습니다.',
  loginRequired: '로그인이 필요합니다.',
} as const;

/** API 기본 타임아웃(ms) */
export const API_TIMEOUT_MS = 15_000;
